import Message from './src/message';

Message.install = (app) => {
    app.config.globalProperties.$message = Message;
};

export default Message;

declare module 'vue' {
    export interface GlobalComponents {
        PtMessage: typeof Message;
    }
}
